import { generaLivello } from "./utility.js";
export default function ultimoLivello(k) {
    k.scene("quartoLivello", () => {
        const LIVELLO = [
            "",
            "",
            "                      ",
            "                    ==",
            " =                M  ",
            "   ===        =====",
            "",
            " @      ========        >",
            "      =",
            "     =.                 ",
            " =======================",
        ];
        generaLivello(k, LIVELLO, "quintoLivello");
    });
}